import { BaseService } from './BaseService';

export interface SendContactMessageData {
  fullName?: string;
  email?: string;
  phoneNumber?: string;
  subject?: string;
  message: string;
}

export class ContactService extends BaseService {
  constructor() {
    super('/api/contact');
  }

  async sendSupportMessage(data: SendContactMessageData): Promise<{ success: boolean; message: string }> {
    return this.post<{ success: boolean; message: string }>('/support', data);
  }
}

export const contactService = new ContactService();
